import axios from 'axios';
import { useConfig } from '../config';

export function useViewProduct() {
	const { api } = useConfig();

	function sendViewProduct(productId: number) {
		const payload = {
			product: productId,
		};
		axios.post(`${api}products/viewed.json`, payload, {
			withCredentials: true,
		});
	}

	return { sendViewProduct };
}
